<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('app.invoice.tabs.record')" name="first" v-if="checkPermi(['order:invoice:list'])">
        <invoiceJl ref="invoiceJlRef"></invoiceJl>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.invoice.tabs.apply')" name="second" v-if="checkPermi(['order:invoice:apply'])">
        <invoiceSq ref="invoiceSqRef" @changeActiveTab="changeActiveTab"></invoiceSq>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import invoiceJl from "@/components/invoice/InvoiceJl.vue";
import invoiceSq from "@/components/invoice/InvoiceSq.vue";
export default {
  name: "invoiceManage",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    invoiceJl,
    invoiceSq
  },
  methods: {
    changeActiveTab() {
      this.activeName = "first";
    },
    handleClick(tab) {
      if (tab.name == "first") {
        this.$refs.invoiceJlRef.initData();
      } else if (tab.name == "second") {
        this.$refs.invoiceSqRef.initData();
      }
    },
  },
  created() {
  },
  mounted() {
    
  },
};
</script>
<style scoped lang="less">

</style>  